import { ReactComponent as Checked } from "../../assets/SVGs/checkbox-checked.svg";
import { ReactComponent as Unchecked } from "../../assets/SVGs/checkbox-empty.svg";

export const EMAIL_REGEX =
  /^[A-Za-z0-9_+#*&?$!.-]+@[A-Za-z0-9_+#*&?$!.-]+\.[A-Za-z]{2,}$/;

export const uncheckedIcon = <Unchecked />;
export const checkedIcon = <Checked />;
